module.exports = __webpack_public_path__ + "img/augmented-reality.d850a775.webp";